var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoomIn1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "56.69px",
    height: "56.69px",
    viewBox: "0 0 56.69 56.69",
    enableBackground: "new 0 0 56.69 56.69",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,28.347c0,15.655,12.691,28.348,28.347,28.348c15.655,0,28.346-12.693,28.346-28.348S44.002,0,28.347,0 C12.691,0,0,12.692,0,28.347"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    cx: 22.582,
    cy: 22.054,
    r: 11.054
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 30.4,
    y1: 29.873,
    x2: 43.434,
    y2: 42.906
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 22.582,
    y1: 16.386,
    x2: 22.583,
    y2: 27.724
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 16.914,
    y1: 22.055,
    x2: 28.252,
    y2: 22.055
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn1);
export default __webpack_public_path__ + "static/media/zoom_in_1.569d61f06d24c2a159cc43d019390455.svg";
export { ForwardRef as ReactComponent };